module.exports = __webpack_public_path__ + "static/media/icon5.d0db0e41.png";